import { render, staticRenderFns } from "./TransferringDetail.vue?vue&type=template&id=72097990&"
import script from "./TransferringDetail.vue?vue&type=script&lang=js&"
export * from "./TransferringDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports